import Helper from '@lovata/popup-helper';
import Validation from '../../../js/validation';
import PhoneMask from '../../../js/inputmask';
import LazyLoad from 'vanilla-lazyload';
//import '../../../js/uploader';

export default new class everModal {
  constructor() {
    this.formData = [];
    this.panelSelector = 'evermodal-dialog__panel';
    this.panelOpenSelector = 'evermodal-dialog__panel_visible';
    this.drawerBtnSelector = 'js-evermodal';
    this.drawerParentSelector = 'body';
    this.drawerOpenBtnSelector = 'evermodal-dialog';
    this.drawerDisableSelector = 'evermodal_empty';
    this.drawerCloseSelector = 'evermodal-dialog-panel__close';

    this.panelForm = 'evermodal-dialog__form';

    this.preloaderSelector = 'evermodal-dialog__preloader';

    this.listWrapperSelector = '_evermodal-form';

    this.handler();
    // this.initSendForm();
  }

  handler() {
    $(document).on('click', `.${this.drawerBtnSelector}`, ({ currentTarget }) => {
      const isDisable = $(currentTarget).hasClass(this.drawerDisableSelector);

      if (isDisable) return;

      const panel = $(currentTarget).parents('body').find(`.${this.panelSelector}`);

      const focusTarget = !panel.hasClass(this.drawerOpenBtnSelector)
        ? document.querySelector(`.${this.drawerCloseSelector}`)
        : document.querySelector(`.${this.drawerOpenBtnSelector}`);
      const isOpen = panel.hasClass(this.panelOpenSelector);

      const purpose = $(currentTarget).data('purpose');

      /*
      console.log(purpose);

      if (typeof purpose === 'undefined') {
        return;
      } 
      */

      const id = $(currentTarget).data('id');
      // const url = $(currentTarget).data('url');
      const data = {
        purpose,
      };

      if (typeof id !== 'undefined') {
        data.id = id;
      }

      Helper.setBodyScrollState(isOpen);
      // Helper.overlayController(!isOpen);

      panel.toggleClass(this.panelOpenSelector);
      Helper.overlayHandler(!isOpen, focusTarget, panel[0]);

      setTimeout(() => {
        Helper.focusTrapManager(!isOpen, panel[0]);
      }, 300);

      this.initSendForm(data, !isOpen);
    });
  }

  initSendForm(data, isOpen) {
    if (!isOpen) return;

    const form = `common/evermodal/form/form-send-${data.purpose}`;

    oc.ajax('EverModal::onAjax', {
      data,
      update: { [form]: `.${this.panelForm}` },
      loading: `.${this.preloaderSelector}`,
      success(response) {
        this.success(response);
        Validation.init();
        PhoneMask.init();
        new LazyLoad;
      },
    });
  }
}();

/* const overlay = this.getOverlay();
        overlay.click(); */
